import { render, staticRenderFns } from "./RoleSection.vue?vue&type=template&id=3dbe0705&"
import script from "./RoleSection.vue?vue&type=script&lang=js&"
export * from "./RoleSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports